import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

class DoctorCommunication {
  audio: boolean;
  chat: boolean;
  video: boolean;
}

export interface DoctorCallStatus {
  callStarted?: boolean;
  successfulCall?: boolean;
  goToSendForm?: boolean;
  formSavedSuccessfully?: boolean;
  data?: {
    consultationId?: string;
    patientId?: string;
  };
}

export enum DoctorCallStatusType {
  callStarted = "callStarted",
  SuccessfulCall = "successfulCall",
  GoToSendForm = "goToSendForm",
  FormSavedSuccessfully = "formSavedSuccessfully",
  data = "data",
}

@Injectable()
export class CallStateService {
  private callState = new BehaviorSubject<any>(false);

  private allCallState = new BehaviorSubject<DoctorCallStatus>({
    callStarted: false,
    successfulCall: false,
    goToSendForm: false,
    formSavedSuccessfully: false,
    data: {},
  });

  cast = this.callState.asObservable();

  updateCallState(data: boolean) {
    this.callState.next(data);
  }

  updateCallStateProperty(property: keyof DoctorCallStatus, value: any) {
    const currentState = this.allCallState.getValue();
    const updatedState = { ...currentState, [property]: value };
    this.allCallState.next(updatedState);
  }

  getCallStateProperty(): Observable<any> {
    return this.allCallState.asObservable();
  }

  cleanAllStateProperties() {
    this.allCallState.next({
      callStarted: false,
      successfulCall: false,
      goToSendForm: false,
      formSavedSuccessfully: false,
      data: {},
    });
  }

  areAllPropertiesTrue(): boolean {
    const currentState = this.allCallState.getValue();
    return Object.values(currentState).every((value) => value === true);
  }
}
